import { Quiz } from './Quiz';
import { ScoreQuizResult } from './ScoreQuizResult';
import { Slide } from './Slide';
import { ScoreQuizQuestion } from './ScoreQuizQuestion';

export class ScoreQuiz extends Quiz {

    public results: ScoreQuizResult[];
    public evaluated: boolean;
    public result: ScoreQuizResult;
    private lastQuestion: Slide;

    public constructor( dto ) {
        super( {
            results: [],
            evaluated: false,
            ...dto,
        } );

        this.lastQuestion = this.slides.reduce( (r, slide) => slide instanceof ScoreQuizQuestion ? slide : r, null );
        this.results = this.results.sort( (a, b) => a.minPoints - b.minPoints );
    }

    public evaluate() {
        this.evaluated = true;
        for( const slide of this.slides ) {
            slide.evaluated = true;
        }
        let score = this.slides.filter( isQuestion )
                               .map( q => q.answers.filter( a => a.selected )[ 0 ]?.points ?? 0 )
                               .reduce( ( sum, points ) => sum + points, 0 );
        this.result = this.results.reduce( ( r, result ) => score >= result.minPoints ? result : r, this.results[ 0 ] );
    }

    public proceed() {
        if( !this.canProceed ) return;

        const nextSlide = this.getNextSlide();
        if( nextSlide ) {
            nextSlide.unlocked = true;
            this.currentSlide = nextSlide;
        }
        else {
            this.close.dispatch();
        }
    }

    protected updateState() {
        super.updateState();

        if( this.currentSlide === this.lastSlide ) {
            this.evaluate();
        }

        if( this.currentSlide.hasInput ) {
            const nextSlide = this.getNextSlide();
            if( nextSlide ) {
                nextSlide.unlocked = true;
            }
        }
    }

    protected updateProceed() {
        super.updateProceed();

        this.proceedLabel = this.currentSlide === this.lastSlide ? 'close'
                          : this.currentSlide === this.lastQuestion && !this.evaluated ? 'checkAnswer'
                          : 'continueQuiz';
    }
}

function isQuestion( slide: Slide ): slide is ScoreQuizQuestion {
    return slide instanceof ScoreQuizQuestion;
}